export default "__VITE_ASSET__DsVLsFdR__"